<template>
  <ckeditor
    v-model="editorData"
    :editor="editor"
    :config="editorConfig"
    :disabled="disabled"
    @ready="isReady = true"
    v-if="isReady"
  />

  <ckeditor
    :editor="editor"
    :config="editorConfig"
    :disabled="disabled"
    @ready="isReady = true"
    v-else
  />
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import "@ckeditor/ckeditor5-build-classic/build/translations/pt-br";

export default {
  name: "RichText",
  props: {
    value: String,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  model: {
    prop: "value",
    event: "change",
  },
  data() {
    return {
      isReady: false,
      editor: ClassicEditor,
      editorConfig: {
        language: "pt-br",
        toolbar: {
          shouldNotGroupWhenFull: true,
        },
      },
    };
  },
  computed: {
    editorData: {
      set(value) {
        this.$emit("change", value);
      },
      get() {
        return this.value ? this.value : "";
      },
    },
  },
};
</script>

<style lang="scss">
.ck-editor__editable {
  min-height: 300px;
}
.ck-editor__editable_inline p {
  margin: 0;
}
</style>
